import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import * as Actions from './store/actions';
import * as NotificationActions from '../notification/store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Button, IconButton } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import ReactTable from "react-table";
import * as moment from 'moment';
import TabPanelButtons from '../../components/TabPanelButtons';
import * as HelperFunctions from '../../components/helpers'; 
const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    },
    button: {
        width: '100%'
    }
});

class NotificationTable extends Component {

    constructor(props) {
        super(props);
        const ccc_id = this.props.match.params.scheduled_course_id;
        this.props.getNotifications(ccc_id);
    }

    handleAdd = () => {
        this.props.setNotificationReference(this.props.relationData)
        this.props.history.push('/notification/create')
    }

    render() {
        const { classes, view_type } = this.props;
        const rows = this.props.notifications;

        return (
            <div>
                <div className="px-24 flex flex-1 justify-end">
                    <TabPanelButtons
                        component_name = {"scheduled_course"}
                        view_type      = {view_type}
                        button_list    = {[
                            {
                                display: "Add",
                                type:    "create",
                                color:   "primary",
                                onClick: () => this.handleAdd(),
                            }
                        ]}
                    />
                </div>
                <ReactTable
                    columns={[
                        {
                            Header: "Notification",
                            accessor: "NotificationHeader",
                        },
                        {
                            Header: "Creation Date",
                            id: "CreationDate",
                            accessor: a => moment(a.CreationDate).format('YYYY-MM-DD h:mm A')
                        },
                        {
                            Header: "Actions",
                            id: "StudentViews",
                            accessor: a =>
                                <div>
                                    <IconButton
                                        onClick={() => this.props.history.push('/notification/detail/' + a.notification_id)}
                                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                    >
                                        <Icon>library_books</Icon>
                                    </IconButton>
                                    {!HelperFunctions.checkPermission(this.props.auth.user.data.permissionList, "scheduled_course", "edit") || view_type === 'detail' ? null :
                                        <IconButton
                                            onClick={() => this.props.history.push('/notification/edit/' + a.notification_id)}
                                            style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                            hidden={this.props.auth.user.role === 'student'}
                                        >
                                            <Icon>border_color</Icon>
                                        </IconButton>
                                    }
                                </div>
                        },

                    ]}
                    data={rows}
                    defaultPageSize={25}
                    className="-striped -highlight"
                    noDataText="No Notifications Found"
                />
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleStudent: Actions.toggleStudent,
        getNotifications: Actions.getNotifications,
        setNotificationReference: NotificationActions.setNotificationReference
    }, dispatch);
}

function mapStateToProps({ scheduledCourseApp, auth }) {
    return {
        auth: auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(NotificationTable)));




// WEBPACK FOOTER //
// src/main/content/scheduled_course/NotificationsTable.js